export const TYPES = {
  NORMAL: 'normal',
  SHOW: 'show',
  EDIT: 'edit',
};

export const PAGES_TYPE_LIST = ['minutes', 'documents', 'voting', 'smart_documents', 'taskboard', 'meetings'];
